<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="公司法人">
                <a-input placeholder="请输入公司法人" v-model="queryParam.corporation"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="单位">
                <a-input placeholder="请输入单位" v-model="queryParam.name"></a-input>
              </a-form-item>
            </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="负责人姓名">
              <a-input placeholder="请输入负责人姓名" v-model="queryParam.principalName"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus"  v-has="'customer:add'" >新增</a-button>
     <!-- <a-button type="primary" icon="download" @click="handleExportXls('pre_customer')">导出</a-button>-->
      <a-dropdown v-if="selectedRowKeys.length > 0" v-has="'customer:batchDelete'" >
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:1000}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        
        <template slot="status" slot-scope="text, record">
          <j-switch v-model="record.status" @change="onSwitchChange(record,$event)"  ></j-switch>
        </template>
        <template slot="emp" slot-scope="text, record">
          <a @click="handlerShowEmployee(record)">{{record.num}}</a>
        </template>
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-has="'customer:edit'">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-has="'customer:detail'">
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item v-has="'customer:delete'">
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <pre-customer-modal ref="modalForm" @ok="modalFormOk" @handlerNextPage="handlerNextPage" />
    <pre-employee-modal ref="employeeModalForm" @ok="modalFormOk" @handlerLastPage="handlerLastPage"  />
    <pre-show-employee-modal ref="showEmployeeModalForm" @ok="modalFormOk" @handlerNextPage="handlerNextPage" />

  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import PreCustomerModal from './modules/PreCustomerModal'
  import PreEmployeeModal from './modules/PreEmployeeModal'
  import PreShowEmployeeModal from './modules/PreShowEmployeeModal'
  import { httpAction, getAction } from '@/api/manage'

  export default {
    name: 'PreCustomerList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      PreCustomerModal,
      PreEmployeeModal,
      PreShowEmployeeModal
    },
    data () {
      return {
        description: 'pre_customer管理页面',
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'物业公司法人',
            align:"center",
            dataIndex: 'propertyCorporation',
            width:200,
            ellipsis:true,
          },
          {
            title:'客户公司法人',
            align:"center",
            width:200,
            ellipsis:true,
            dataIndex: 'corporation'
          },
          {
            title:'单位',
            align:"center",
            dataIndex: 'name',
            width:200,
            ellipsis:true,
          },
          {
            title:'负责人',
            align:"center",
            dataIndex: 'principalName',
            width:160,
          },
          {
            title:'系统账号',
            align:"center",
            dataIndex: 'principalAccount',
            width:160,
          },
          {
            title:'工号',
            align:"center",
            dataIndex: 'employeeNo',
            width:160,
          },
          {
            title:'手机',
            align:"center",
            dataIndex: 'principalMobile',
            width:160,
          },
          {
            title:'厂区-区域-楼栋',
            align:"center",
            dataIndex: 'buildings',
            width:300,
            ellipsis:true,
          },
          {
            title:'成员',
            align:"center",
            dataIndex: 'num',
            width:50,
            scopedSlots: { customRender: 'emp'}
          },
          {
            title:'创建人',
            align:"center",
            dataIndex: 'createBy',
            width:160,
          },
          {
            title:'创建时间',
            align:"center",
            dataIndex: 'createTime',
            width:160,
          },
          {
            title:'是否启用',
            align:"center",
            dataIndex: 'status',
            scopedSlots: { customRender: 'status'}
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/prevent/customer/list",
          delete: "/prevent/customer/delete",
          deleteBatch: "/prevent/customer/deleteBatch",
          switchChange:'/prevent/customer/switchChange',
          exportXlsUrl: "/prevent/customer/",
          importExcelUrl: "prevent.datamaster/import-excel",

        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {
    this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
       username() {
        return this.$store.getters.userInfo.username
      },
      handlerNextPage(model) {
        console.log('2222 model : ',model)
        this.handleAddEmployee(model)
      },

      handlerLastPage(lastModel) {
       this.handleAddCustomer(lastModel)
      },

      handleAddEmployee: function (model) {
        this.$refs.employeeModalForm.setModel(model);
        this.$refs.employeeModalForm.add();
        this.$refs.employeeModalForm.title = "新增";
        this.$refs.employeeModalForm.disableSubmit = false;
      },

      handleAddCustomer: function (lastModel) {
        console.log('lastModel : ',lastModel)
        this.$refs.modalForm.edit(lastModel);
        this.$refs.modalForm.title = "新增";
        this.$refs.modalForm.disableSubmit = false;
      },

      //pageState 1: 编辑  2 :成员 3: 详情
      handleEdit: function (record) {
        record.pageState = 1
        this.$refs.modalForm.disableSubmit = false;
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = "编辑";
      },
      handleDetail:function(record){
         record.pageState = 3
        this.$refs.modalForm.disableSubmit = true;
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title="详情";
      },

      handlerShowEmployee(record) {
      //  this.$refs.showEmployeeModalForm.setModel(model);
        record.pageState = 2
        this.$refs.showEmployeeModalForm.show(record);
        this.$refs.showEmployeeModalForm.title = "查看成员";
        this.$refs.showEmployeeModalForm.disableSubmit = false;
      },

      onSwitchChange(val,checked) {
        getAction(this.url.switchChange, {id:val.id,status:checked}).then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.$emit('ok')
          } else {
            this.$message.warning(res.message)
          }
        })
      },
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'propertyCorporation',text:'物业公司法人',dictCode:''})
        fieldList.push({type:'string',value:'propertyName',text:'物业单位名称',dictCode:''})
        fieldList.push({type:'string',value:'corporation',text:'公司法人',dictCode:''})
        fieldList.push({type:'string',value:'name',text:'单位名称',dictCode:''})
        fieldList.push({type:'int',value:'status',text:'是否启用',dictCode:''})
        fieldList.push({type:'string',value:'principalId',text:'负责人用户ID',dictCode:''})
        fieldList.push({type:'string',value:'delFlag',text:'是否删除',dictCode:''})
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
